import { Button, Grid } from "@material-ui/core";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import SelectPagingCheckBoxDetail from "./SelectPagingCheckBoxDetail";
import { useFormikContext } from "formik";
import { pagingOrganization } from "app/services/OrganizationService";
import { getDepartmentsUser, isAdmin } from "app/common/LocalFunction";
const SearchChart = () => {
  const { touched, errors, setFieldValue, values } = useFormikContext();
  const isAdmins = isAdmin();
  const departmentsUser = getDepartmentsUser();

  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsMultiDatePicker
            label="Từ ngày - đến ngày"
            name="fromDate"
            range
            rangeHover
            fromField="fromDate"
            toField="toDate"
          // format={"DD/MM/YYYY"}
          />
          {touched.toDate && errors.toDate && (
            <div style={{ color: "red", fontSize: 12 }}>{errors.toDate}</div>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <SelectPagingCheckBoxDetail
            name={"orgIds"}
            label={"Khu vực"}
            api={pagingOrganization}
            listSelected={values?.orgIds || []}
            setListOption={(orgIds) => {
              setFieldValue("orgIds", orgIds);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <SelectPagingCheckBoxDetail
            name={"departmentIds"}
            label={"Cơ sở"}
            api={
              isAdmins
                ? pagingDepartment
                : async () => ({
                  data: { content: departmentsUser || [] },
                })
            }
            listSelected={values?.departmentIds || []}
            setListOption={(departmentIds) => {
              setFieldValue("departmentIds", departmentIds);
            }}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md="auto" className="flex flex-end gap-2">
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(SearchChart));
